import idx from 'idx';
import React from 'react';

import { QueryResult, MutationFn } from 'react-apollo';
// @ts-ignore
import AccountLinkingComposerSidebar from 'chat/components/AccountLinkingComposerSidebar';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import BoxHeader from 'components/BoxHeader';
import Button from 'components/Button';
import GET_CONTENT_SOURCE_PROVIDER_QUERY from '../queries/ContentSourceProviderQuery.gql';
import Heading from 'components/Heading';
import LoadingIndicator from 'components/LoadingIndicator';
import Text from 'components/Text';
import ToastActions from 'actions/ToastActions';
import unlinkAccountMutation from 'user/mutations/unlinkAccount.gql';
import {
  UnlinkAccountVariables,
  UnlinkAccount,
} from 'src/user/mutations/__generated__/UnlinkAccount';
import { HoCQueryComponent, HoCMutationComponent } from 'types/typescript/util';

import {
  ContentSourceProviderContainer,
  ContentSourceProviderContainerVariables,
} from '../queries/__generated__/ContentSourceProviderContainer';

import './styles/ContentSourceProviderPreview.scss';

type IncomingProps = {
  uuid: string;
  unlinkAccount: MutationFn<UnlinkAccount, UnlinkAccountVariables>;
};

type Props = {
  apolloProps: QueryResult<ContentSourceProviderContainer, ContentSourceProviderContainerVariables>;
};

type State = {
  key: number;
};

class ContentSourceProviderPreview extends React.Component<Props & IncomingProps, State> {
  state: State = {
    key: 0,
  };

  contentSourceProviderKey = (): string | undefined =>
    this.props.apolloProps.data?.contentSourceProvider?.providerKey;
  refresh = () => this.setState({ key: this.state.key + 1 });
  refreshAndReset = () => {
    const key = this.contentSourceProviderKey();
    if (key) {
      this.props
        .unlinkAccount({ variables: { provider: key } })
        .then(this.refresh)
        .catch(() => ToastActions.showErrorToast('Unable to reset. Please try again later.'));
    } else {
      this.refresh();
    }
  };
  handleLinkedContent = (e: any) => ToastActions.showSuccessToast(`Success! ${e.title}`);

  render() {
    if (this.props.apolloProps.loading) {
      return <LoadingIndicator height={500} size="medium" />;
    }

    return (
      <div className="ContentSourceProviderPreview" key={this.state.key}>
        <Box>
          <BoxHeader title="Composer Playground" />
          <BoxBody divided className="ContentSourceProviderPreview-body">
            <AccountLinkingComposerSidebar
              fetchPolicy="network-only"
              addLinkedContent={this.handleLinkedContent}
            />
          </BoxBody>
          <BoxFooter className="ContentSourceProviderPreview-BoxFooter">
            <div className="ContentSourceProviderPreview-BoxFooter-item">
              <div>
                <Heading level="3" levelStyle="5">
                  Refresh content webhooks
                </Heading>
                <Text>
                  Manually refresh the playground after saving your content webhook changes.
                </Text>
              </div>
              <Button level="secondary" onClick={this.refresh}>
                Refresh
              </Button>
            </div>
            <div className="ContentSourceProviderPreview-BoxFooter-item">
              <div>
                <Heading level="3" levelStyle="5">
                  Reset authentication
                </Heading>
                <Text>If you’ve linked an account with OAuth it will be un-linked.</Text>
              </div>
              <Button level="secondary" onClick={this.refreshAndReset}>
                Reset
              </Button>
            </div>
          </BoxFooter>
        </Box>
      </div>
    );
  }
}

const withUnlinkAccountMutation = HoCMutationComponent<
  UnlinkAccount,
  UnlinkAccountVariables,
  IncomingProps
>({ mutation: unlinkAccountMutation }, 'unlinkAccount');

const withTheContentSourceProvider = HoCQueryComponent<
  ContentSourceProviderContainer,
  ContentSourceProviderContainerVariables,
  IncomingProps
>({
  query: GET_CONTENT_SOURCE_PROVIDER_QUERY,
  fetchPolicy: 'cache-only',
  variablePropKeys: [{ varName: 'uuid', propName: 'uuid' }],
});

export { ContentSourceProviderPreview };
export default withUnlinkAccountMutation(
  withTheContentSourceProvider(ContentSourceProviderPreview)
);
